module.exports = __webpack_public_path__ + "media/dobry_wzor/dobry-wzor-laureat-img-2@2x-b1df170c.png";